import type { IpAddressWhitelistInlineFormValues } from '@/features/ip_address_whitelists/IpAddressWhitelistList/types';
import { useIpAddressWhitelistIpRules } from '@/features/ip_address_whitelists/hooks/useIpAddressWhitelistIpRules';
import type { IpAddressWhitelistTableRow } from '@/features/ip_address_whitelists/type';
import { FormInput } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import type { Control } from 'react-hook-form';
import styles from '../column.module.scss';

const cx = classnames.bind(styles);

type Props = {
  row: IpAddressWhitelistTableRow;
  editingRowId: string | null;
  inlineFormControl: Control<IpAddressWhitelistInlineFormValues>;
};

export const IpAddressWhitelistIpCell: FC<Props> = memo(
  ({ row, editingRowId, inlineFormControl }) => {
    const ipRules = useIpAddressWhitelistIpRules();

    if (row.id === editingRowId) {
      return (
        <div className={cx('inline-cell')}>
          <FormInput<IpAddressWhitelistInlineFormValues>
            control={inlineFormControl}
            name='ip_address'
            inputId='ip_address_whitelist_inline_ip'
            testId='ip_address_whitelist_inline_ip'
            rules={ipRules}
          />
        </div>
      );
    }
    return <span className={cx('ip-value')}>{row.ip_address}</span>;
  }
);
IpAddressWhitelistIpCell.displayName = 'IpAddressWhitelistIpCell';
